"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 23 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var CompetitorPriceConverter_1 = require("./conversions/CompetitorPriceConverter");

var CompetitorPriceConverterImpl_1 = require("./conversions/CompetitorPriceConverterImpl");

var BindDTOConverter_1 = require("./conversions/dto/BindDTOConverter");

var BindDTOConverterImpl_1 = require("./conversions/dto/BindDTOConverterImpl");

var BindIdsDTOConverter_1 = require("./conversions/dto/BindIdsDTOConverter");

var BindIdsDTOConverterImpl_1 = require("./conversions/dto/BindIdsDTOConverterImpl");

var CompetitorProductBindDTOConverter_1 = require("./conversions/dto/CompetitorProductBindDTOConverter");

var CompetitorProductBindDTOConverterImpl_1 = require("./conversions/dto/CompetitorProductBindDTOConverterImpl");

var CompetitorProductDTOConverter_1 = require("./conversions/dto/CompetitorProductDTOConverter");

var CompetitorProductDTOConverterImpl_1 = require("./conversions/dto/CompetitorProductDTOConverterImpl");

var DataPairingProductRowDTOConverter_1 = require("./conversions/dto/DataPairingProductRowDTOConverter");

var DataPairingProductRowDTOConverterImpl_1 = require("./conversions/dto/DataPairingProductRowDTOConverterImpl");

var DataPairingStatsDTOConverter_1 = require("./conversions/dto/DataPairingStatsDTOConverter");

var DataPairingStatsDTOConverterImpl_1 = require("./conversions/dto/DataPairingStatsDTOConverterImpl");

var PriceClassificationsBindingConverter_1 = require("./conversions/PriceClassificationsBindingConverter");

var PriceClassificationsBindingConverterImpl_1 = require("./conversions/PriceClassificationsBindingConverterImpl");
/**
 * Configures data-pairing app module.
 *
 * @author RV
 */


var DataPairingAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(DataPairingAppModule, _AppModule_1$AppModul);

  function DataPairingAppModule() {
    var _this;

    _classCallCheck(this, DataPairingAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataPairingAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'dataPairingAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(DataPairingAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(CompetitorPriceConverter_1.CompetitorPriceConverter).to(CompetitorPriceConverterImpl_1.CompetitorPriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceClassificationsBindingConverter_1.PriceClassificationsBindingConverter).to(PriceClassificationsBindingConverterImpl_1.PriceClassificationsBindingConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataPairingProductRowDTOConverter_1.DataPairingProductRowDTOConverter).to(DataPairingProductRowDTOConverterImpl_1.DataPairingProductRowDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompetitorProductDTOConverter_1.CompetitorProductDTOConverter).to(CompetitorProductDTOConverterImpl_1.CompetitorProductDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompetitorProductBindDTOConverter_1.CompetitorProductBindDTOConverter).to(CompetitorProductBindDTOConverterImpl_1.CompetitorProductBindDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataPairingStatsDTOConverter_1.DataPairingStatsDTOConverter).to(DataPairingStatsDTOConverterImpl_1.DataPairingStatsDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(BindDTOConverter_1.BindDTOConverter).to(BindDTOConverterImpl_1.BindDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(BindIdsDTOConverter_1.BindIdsDTOConverter).to(BindIdsDTOConverterImpl_1.BindIdsDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return DataPairingAppModule;
}(AppModule_1.AppModule);

exports.DataPairingAppModule = DataPairingAppModule;